/**
 * Determines the current environment based on the hostname
 *
 * @returns {"development" | "staging" | "production"}
 */
export const getEnv = () => {
  const hostname = window.location.hostname;
  if (/www\.pagerduty\.com/.test(hostname)) return "production";
  else if (/staging/.test(hostname)) return "staging";
  return "development";
};

export const isProd = () => getEnv() === "production";
